import { createContext, useContext, ReactNode } from 'react'
import { SxProps, Theme } from '@mui/system'
import { useStyles } from '../styles'
import { useContextState } from '../../../../../../../hooks/theme'
import { icons } from '../../../../../../../utils/icons'
import { useTranslation } from 'react-i18next'

interface StorePerformanceContextValue {
  styles: ReturnType<typeof useStyles>
  colors: ReturnType<typeof useContextState>['colors']
  icons: typeof icons
  t: (key: string, options?: Record<string, unknown>) => string
}

const StorePerformanceContext = createContext<StorePerformanceContextValue | null>(null)

interface StorePerformanceProviderProps {
  children: ReactNode
}

const StorePerformanceProvider = ({ children }: StorePerformanceProviderProps) => {
  const styles = useStyles()
  const { colors } = useContextState()
  const { t } = useTranslation()

  return (
    <StorePerformanceContext.Provider value={{ styles, colors, icons, t }}>
      {children}
    </StorePerformanceContext.Provider>
  )
}

const useStorePerformanceContext = (): StorePerformanceContextValue => {
  const context = useContext(StorePerformanceContext)
  if (!context) {
    throw new Error('useStorePerformanceContext must be used within StorePerformanceProvider')
  }
  return context
}

export { StorePerformanceProvider, useStorePerformanceContext }
